
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    buttonText: {
      type: String,
      default: 'Διαθεσιμότητα',
    },
    title: {
      type: String,
      default: 'Διαθεσιμότητα σε καταστήματα',
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
      expandedItems: {},
      pharmacies: {
        "Φαρμακείο Περιστερίου": {
          title: "Φαρμακείο Περιστέρι",
          address: "Θηβών 201, Περιστέρι, 12134",
          link:"https://maps.app.goo.gl/QA8n7VmmB6b1GqwJ9",
          phone: "210 2241220"
        },
        "Φαρμακείο Αγ. Δημητρίου": {
          title: "Φαρμακείο Άγιος Δημήτριος",
          address: "Λεωφ. Αγίου Δημητρίου 295, 17342",
          link:"https://maps.app.goo.gl/cMa1jQ2n1A59Jpio9",
          phone: "210 9850072"
        },
        "Φαρμακείο Σπατών": {
          title: "Φαρμακείο Σπάτα",
          address: "Οικοδ. τετρ. Ε71 θέση Γιαλού (Designer Outlet Athens)",
          link:"https://maps.app.goo.gl/uG7xjArM8KYtvekK6",
          phone: "210 2241900"
        },
        "Φαρμακείο Κηφισιάς": {
          title: "Φαρμακείο Κηφισιά",
          address: "Κασσαβέτη 6, Κηφισιά 14562",
          link:"https://maps.app.goo.gl/8s25ExmSGQqgzGSv6",
          phone: "210 3002295"
        },
        "Φαρμακείο Ελληνικού": {
          title: "Φαρμακείο Ελληνικό",
          address: "Τιτάνων 17, Ελληνικό 16777",
          link:"https://maps.app.goo.gl/3mdgbo2g2k4US4b67",
          phone: "210 2241095"
        }
      }
    };
  },
  computed: {
    isSingleItem() {
      return this.items.length === 1;
    },
  },
  watch: {
    open(val) {
      if (val && this.expandAll) {
        // Expand all items when modal opens if expandAll is true
        this.items.forEach((_, index) => {
          this.$set(this.expandedItems, index, true);
        });
      }
    },
  },
  methods: {
    toggleItem(index) {
      if (this.isSingleItem) return;
      this.$set(this.expandedItems, index, !this.expandedItems[index]);
    },
    getItemImage(item) {
      return item?.images?.[0] || item?.image || item?.img || null;
    },
    getSortedStores(item) {
      const stores = item?.availability?.stores || [];
      return [...stores].sort((a, b) => {
        // Sort by stock (available first), then by order
        if (a.stock > 0 && b.stock === 0) return -1;
        if (a.stock === 0 && b.stock > 0) return 1;
        return (a.order || 0) - (b.order || 0);
      });
    },
    getStockClass(stock) {
      if (stock > 3) return 'bg-green-100 text-green-600';
      if (stock > 0) return 'bg-yellow-100 text-yellow-600';
      return 'bg-red-100 text-red-600';
    },
    getStockDotClass(stock) {
      if (stock > 3) return 'bg-green-500';
      if (stock > 0) return 'bg-yellow-500';
      return 'bg-red-500';
    },
    getAvailabilityText(store) {
      if (store.stock > 3) return 'Διαθέσιμο';
      if (store.stock > 0) return 'Περιορισμένη διαθεσιμότητα';
      return 'Μη διαθέσιμο';
    },
    getItemAvailabilitySummary(item) {
      const stores = item?.availability?.stores || [];
      const availableStores = stores.filter(s => s.stock > 0).length;
      const totalStores = stores.length;

      return `Διαθέσιμο σε ${availableStores}/${totalStores} φαρμακεία`;
    },
  },
};
